var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#16304F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.998H19V23.998C19 24.2633 18.8946 24.5176 18.7071 24.7052C18.5196 24.8927 18.2652 24.998 18 24.998C17.7348 24.998 17.4804 24.8927 17.2929 24.7052C17.1054 24.5176 17 24.2633 17 23.998V18.998H12C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998C11 17.7328 11.1054 17.4785 11.2929 17.2909C11.4804 17.1034 11.7348 16.998 12 16.998H17V11.998C17 11.7328 17.1054 11.4785 17.2929 11.2909C17.4804 11.1034 17.7348 10.998 18 10.998C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998V16.998H24C24.2652 16.998 24.5196 17.1034 24.7071 17.2909C24.8946 17.4785 25 17.7328 25 17.998C25 18.2633 24.8946 18.5176 24.7071 18.7052C24.5196 18.8927 24.2652 18.998 24 18.998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClient);
export default __webpack_public_path__ + "static/media/AddClient.c5784575c6c95945c7ecff96de6e9369.svg";
export { ForwardRef as ReactComponent };